import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Search, Library, Radio, ListMusic, Upload, Heart, Plus, Waves, ShieldCheck } from 'lucide-react';
import { sidebarPlaylists } from '../mock';
import { useAuth } from '../context/AuthContext';

const navItems = [
  { icon: Home, label: 'Home', path: '/' },
  { icon: Search, label: 'Browse', path: '/browse' },
  { icon: Radio, label: 'GCL Radio', path: '/radio' },
  { icon: ListMusic, label: 'Charts', path: '/charts' },
  { icon: Upload, label: 'Submit Music', path: '/submit', highlight: true },
];

const Sidebar = () => {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const items = [...navItems];
  if (user?.role === 'super_admin') {
    items.push({ icon: ShieldCheck, label: 'Admin', path: '/admin', highlight: true });
  }
  return (
    <aside className="hidden md:flex flex-col w-64 bg-[#050506] border-r border-white/5 h-[calc(100vh-90px)] sticky top-0">
      {/* Logo */}
      <div className="px-6 pt-6 pb-4">
        <Link to="/" className="flex items-center gap-2 group">
          <div className="w-9 h-9 rounded-full bg-gradient-to-br from-orange-500 to-rose-600 flex items-center justify-center shadow-lg shadow-orange-500/20">
            <Waves className="w-5 h-5 text-white" />
          </div>
          <div className="leading-tight">
            <div className="font-display text-lg text-white">GULF COAST</div>
            <div className="text-[10px] tracking-[0.28em] text-orange-400 -mt-1">LATINO</div>
          </div>
        </Link>
      </div>

      {/* Primary Nav */}
      <nav className="px-3 pb-4">
        <ul className="space-y-1">
          {items.map(({ icon: Icon, label, path, highlight }) => {
            const active = pathname === path;
            return (
              <li key={label}>
                <Link
                  to={path}
                  className={`flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-colors ${
                    active
                      ? 'bg-white/10 text-white'
                      : 'text-neutral-400 hover:text-white hover:bg-white/5'
                  } ${highlight ? 'text-orange-400 hover:text-orange-300' : ''}`}
                >
                  <Icon className="w-[18px] h-[18px]" />
                  <span className="font-medium">{label}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>

      <div className="px-6 pt-2 pb-2 flex items-center justify-between">
        <div className="flex items-center gap-2 text-neutral-400 text-xs uppercase tracking-wider">
          <Library className="w-4 h-4" /> Your Crate
        </div>
        <button className="text-neutral-400 hover:text-white transition-colors">
          <Plus className="w-4 h-4" />
        </button>
      </div>

      <div className="px-3 flex-1 overflow-y-auto gcl-scroll">
        <button className="w-full flex items-center gap-3 px-3 py-2 rounded-md text-neutral-300 hover:bg-white/5 hover:text-white transition-colors text-sm">
          <div className="w-8 h-8 rounded bg-gradient-to-br from-orange-400 to-pink-500 flex items-center justify-center">
            <Heart className="w-4 h-4 text-white" fill="currentColor" />
          </div>
          <div className="text-left">
            <div className="text-sm text-white">Liked Songs</div>
            <div className="text-[11px] text-neutral-500">142 tracks</div>
          </div>
        </button>

        {sidebarPlaylists.slice(1).map((p) => (
          <button key={p} className="w-full flex items-center gap-3 px-3 py-2 rounded-md hover:bg-white/5 transition-colors text-left">
            <div className="w-8 h-8 rounded bg-white/5 border border-white/5 flex items-center justify-center">
              <ListMusic className="w-4 h-4 text-neutral-400" />
            </div>
            <div>
              <div className="text-sm text-neutral-200">{p}</div>
              <div className="text-[11px] text-neutral-500">Playlist · You</div>
            </div>
          </button>
        ))}

        <div className="mt-4 mx-2 p-4 rounded-lg bg-gradient-to-br from-orange-500/10 to-rose-600/10 border border-orange-500/20">
          <div className="text-sm font-semibold text-white mb-1">Artist? Get in the crate.</div>
          <div className="text-xs text-neutral-400 mb-3">Submit your track directly to Gulf Coast DJs.</div>
          <Link
            to="/submit"
            className="inline-block px-3 py-1.5 text-xs font-semibold rounded-full bg-white text-black hover:bg-neutral-200 transition-colors"
          >
            Submit Music
          </Link>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
